module.exports = __webpack_public_path__ + "img/HD_gg_yq_1_1e2052ba8.png";